import { DialogModal } from "@common/components/alert/dialog/DialogModal"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import React, { useState } from "react"
import { TouchableOpacity, View } from "react-native"

export const MaterialPdf = (props) => {
    const {
        onClear,
        renderIconButton,
        canDeleteFile,
        handleShowMaterialModal = () => {},
        title = "PDF",
        description,
    } = props

    const [confirmModalVisible, setConfirmModalVisible] = useState(false)

    return (
        <>
            <TouchableOpacity
                style={{
                    backgroundColor: theme.colors.primaryLighter,
                    borderRadius: theme.roundness,
                    marginTop: 20,
                    padding: 20,
                }}
                onPress={handleShowMaterialModal}
                disabled={props.canOpenFile === false}
            >
                <View
                    style={{
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "stretch",
                        alignSelf: "center",
                    }}
                >
                    <View
                        style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <TextM
                            wrap
                            fontWeight="ExtraBold"
                            color={theme.colors.primary}
                            fontSize={18}
                            style={{}}
                        >
                            {title || "PDF"}
                        </TextM>
                        <TextM
                            wrap
                            fontWeight="Regular"
                            color={theme.colors.grey}
                            fontSize={14}
                            style={{}}
                        >
                            {description}
                        </TextM>
                    </View>
                    {canDeleteFile &&
                        renderIconButton(() => {
                            setConfirmModalVisible(true)
                        })}
                </View>
            </TouchableOpacity>

            <DialogModal
                visible={confirmModalVisible}
                onDismiss={() => setConfirmModalVisible(false)}
                title="Retirer le fichier ?"
                onConfirm={onClear}
            />
        </>
    )
}
